import SVGIconWrapper from "./SVGIconWrapper"

const IconAngleDownBold = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 500 298.6"
        iconClass={`icon--angle-down-bold ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M250 298.6l250-250L451.4 0 250 201.4 48.6 0 0 48.6l250 250" />
    </SVGIconWrapper>
)

export default IconAngleDownBold